import { render, staticRenderFns } from "./regis_school.vue?vue&type=template&id=b374f4b0&scoped=true"
import script from "./regis_school.vue?vue&type=script&lang=js"
export * from "./regis_school.vue?vue&type=script&lang=js"
import style0 from "./regis_school.vue?vue&type=style&index=0&id=b374f4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b374f4b0",
  null
  
)

export default component.exports